var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bottom-wrapper" },
    [
      _c("zcy-comp-labels"),
      _vm._v(" "),
      _c("div", { staticClass: "hr" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bottom-link-wrapper" },
        [
          _c("zcy-comp-links"),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c("zcy-comp-wechat")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aaf6b604", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaf6b604","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom/index.vue
// module id = ak5R
// module chunks = 1 2 3 4 5 6 7 8 9